import { Injectable, signal,Signal, WritableSignal } from '@angular/core';
import {TableRow} from '../../shared/models/components/tables/table.models';
import { StrategyRules } from '../models/store/strategyRules.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', 
})
export class SharedDataService {


  private dataSource = signal<any[]>([]); 
  private project: WritableSignal<string> = signal('');
  private _rowsSummary: WritableSignal<TableRow[]> = signal([]);
  private _rowsAllTrades: WritableSignal<TableRow[]> = signal([]);
  private _rowsSummaryModelAccuracy: WritableSignal<TableRow[]> = signal([]);
  private _rowsAllTradesModelAccuracy: WritableSignal<TableRow[]> = signal([]);
  private originalRowsAllTradesModelAccuracy: WritableSignal<TableRow[]> = signal([]); 
  private originalRowsAllTrades: WritableSignal<TableRow[]> = signal([]); 
  private strategyRules: StrategyRules = {
    entryDifferencePercentage: '',
    entryDifferenceValue: '',
    exitDifferencePercentage: '', 
    exitDifferenceValue: '',
    stopLossPercentage: '',
    stopLossValue: '',
    takeProfitPercentage: '',
    takeProfitValue: ''
  }; 

  // private tabIndexSubject = new BehaviorSubject<number>(0);
  // tabIndex$ = this.tabIndexSubject.asObservable();
  
  private _isFirstLoad: boolean = true;

  setStrategyRules(strategyRules: StrategyRules) {
    this.strategyRules = strategyRules;
  }

  getStrategyRules(): StrategyRules {
    return this.strategyRules;
  }

  // setActiveTab(index: number) {
  //   this.tabIndexSubject.next(index);
  // }

  get getIsFirstLoad(): boolean {
    return this._isFirstLoad;
  }

  set setIsFirstLoad(value: boolean) {
    this._isFirstLoad = value;
  }

  get currentData() {
    return this.dataSource();
  }

  updateData(newData: any[]) {
    this.dataSource.set([...newData]); 
  }

  setProject(project: string) {
    this.project.set(project);
}

  getProject():string{
    return this.project();
  }

  setRowsSummary(data: TableRow[]) {
    this._rowsSummary.set(data);
  }
  setRowsSummaryModelAccuracy(data: TableRow[]) {
    this._rowsSummaryModelAccuracy.set(data);
  }
  getRowsSummary(): WritableSignal<TableRow[]> {
    return this._rowsSummary;
  }

  setRowsAllTrades(data: TableRow[]) {
    this._rowsAllTrades.set(data);
  }
  setRowsAllTradesModelAccuracy(data: TableRow[]) {
    this._rowsAllTradesModelAccuracy.set(data);
 
  }
  getRowsAllTrades(): WritableSignal<TableRow[]> {
    return this._rowsAllTrades;
  }
  getRowsAllTradesModelAccuracy(): WritableSignal<TableRow[]> {
    
    return this._rowsAllTradesModelAccuracy;
  }
  setOriginalRowsAllTradesModelAccuracy(data: TableRow[]): void {
    this.originalRowsAllTradesModelAccuracy.set(data);
  }
  getOriginalRowsAllTradesModelAccuracy(): TableRow[] {
    return this.originalRowsAllTradesModelAccuracy();
  }

  getOriginalRowsAllTrades(): TableRow[] {
    return this.originalRowsAllTrades();
  }

  setOriginalRowsAllTrades(data: TableRow[]): void {
    this.originalRowsAllTrades.set(data);
  }
}
